import axios from "axios";

import { IP } from "../utils/Host";


export function dragDropProcesGrupaToProcesorOprawa(draggedId,targetProcesorId,fechGrupyOprawaForProcesor) {

// id = procesor id
  
axios
  .get(IP + "API_0013_drag_drop_proces_grupa_to_procesor_oprawa/" + draggedId + "/" + targetProcesorId)
  .then((res) => {
    const { id } = res.data;
    
    // console.log(`Zadanie przeniesione z procesora ${old_procesor_id} na ${new_procesor_id}`);
    
    // Odświeżamy widok dla obu maszyn, żeby uniknąć tzw. "ghost tasks"
    fechGrupyOprawaForProcesor(id);
    console.log(id)
    // if (old_procesor_id !== new_procesor_id) {
    //     fechGrupyAndWykonaniaForProcesor(new_procesor_id);
    // }
  })
  .catch((err) => {
    console.error("Błąd zapytania:", err);
  });
}
